import anime from "animejs";
import ScrollMagic from "scrollmagic";

import "./services.scss";

const services = () => {
  let sections = document.querySelectorAll(".services");
  if (!sections.length) return;
  sections.forEach((el, i) => {
    let cards = el.querySelectorAll(".services__card");
    if (!cards.length) return;
    cards.forEach((card, c) => {
      let button = card.querySelector(".button");
      card.addEventListener("mouseover", (evt) => {
        button.classList.add("over");
      });
      card.addEventListener("mouseleave", (evt) => {
        button.classList.remove("over");
      });
      const animation = () => {
        anime.timeline({ loop: false }).add({
          targets: card,
          opacity: [0, 1],
          translateY: [50, 0],
          easing: "easeInOutQuad",
          duration: 500,
          delay: (el, i) => 50 * (i + 1),
        });
      };
      const controller = new ScrollMagic.Controller();
      const scene = new ScrollMagic.Scene({
        triggerHook: "onEnter",
        triggerElement: card,
        reverse: false,
      })
        .on("start", () => {
          animation();
        })
        .addTo(controller);
    });
  });
};

export default services;
